import * as React from "react";
import { memo } from "react";
const SvgLandingBottomSliver = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", xmlns: "http://www.w3.org/2000/svg", width: 416, height: 28, viewBox: "0 0 416 28", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M405.532 28L416 -1.90735e-06H0L405.532 28Z", fill: "#011936" }));
const Memo = memo(SvgLandingBottomSliver);
export default Memo;
